import ErrorComponent, { Illustration } from './ErrorComponent'
import ServerErrorComponent from './ServerErrorComponent'

export default ErrorComponent
export { ServerErrorComponent, Illustration }
